export default "__VITE_ASSET__B9uvu7A4__"